import { Injectable } from "@angular/core";
import { BehaviorSubject, take } from "rxjs";
import { LoginService } from "src/app/core/services/login.service";
import { ElementsService } from "src/proxy";
import { StoreModel } from "../models/model.store";

@Injectable()
export class UnitStoreService {

    _units$ = new BehaviorSubject<StoreModel>(null);

    constructor(
        private elementsService: ElementsService,
        private loginService: LoginService
    ) {
    }

    reloadUnits() {
        const projectTemplate = this.loginService.projectTemplate;
        this.loadUnit().pipe(take(1)).subscribe(data => {
            this.unit = { data, projectId: projectTemplate.project.id, templateId: projectTemplate.template.id };
        });
    }

    loadUnit() {
        return this.elementsService.getUnits();
    }

    get unit() {
        return this._units$.value;
    }

    set unit(data: StoreModel) {
        this._units$.next(data);
    }

    get unit$() {
        return this._units$;
    }
}